import { render, staticRenderFns } from "./contact-us.vue?vue&type=template&id=00fd54c9"
import script from "./contact-us.vue?vue&type=script&lang=js"
export * from "./contact-us.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/johnson/WebStormProject/zm/zm-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('00fd54c9')) {
      api.createRecord('00fd54c9', component.options)
    } else {
      api.reload('00fd54c9', component.options)
    }
    module.hot.accept("./contact-us.vue?vue&type=template&id=00fd54c9", function () {
      api.rerender('00fd54c9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/system-management/aboutcontacting-managment/contact-us.vue"
export default component.exports